import { getEditLocation } from "../../../core/util/functions";
export const ctrlGoodsLocation = "/cliring/paymentsdelivery/control";
export const getCtrlGoodsEditLocation = (id?: string) =>
  getEditLocation(ctrlGoodsLocation, undefined, id);

export const editRouter = getCtrlGoodsEditLocation(":ctrlId?");
